import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';

export default function PublicRoute() {
  const currentUser = useSelector((state) => state?.user?.currentUser);

  if (currentUser?.role == 'admin' || currentUser?.role == 'SuperAdmin') {
    return <Navigate to="/overall" />;
  }
  if(currentUser?.role == 'Agencies' || currentUser?.role == 'StucredAgencies'){
    return <Navigate to='/Agency_loan_details'/>
  }
  if(currentUser?.role == 'StucredAgent'){
    return <Navigate to='/stucred_loan'/>
  }
 
if (
  currentUser?.role == "Inhouse-Manger-Chennai" ||
  currentUser?.role == "Inhouse-Manger-Indore" ||
  currentUser?.role == "Inhouse-Manger-Banglore" ||
  currentUser?.role == "Inhouse-Manger-Mumbai" ||
  currentUser?.role == "Inhouse-Manger-Hyderabad" ||
  currentUser?.role == "Inhouse-Manger-Kolkata" ||
  currentUser?.role == "Inhouse-Manger-Delhi" ||
  currentUser?.role == "Inhouse-Manger-Pune"
) {
  return <Navigate to="/Manager_loan_details" />;
}
  // If not logged in, allow them to access the login page (the / route)
  return <Outlet />;
}